import React from "react";
import { Box } from "@mui/material";

import DashboardCard from "../Common/DashboardCard";
import SectionHeader from "../Common/SectionHeader";

import ProjectSummary from "./ProjectSummary";
import ProjectList from "./ProjectList";

import { mapProjectToCard } from "../dashboardTransforms";

export default function ProjectsSection({
    rawProjects = [],
    onViewAll,
    onOpenProject,
}) {
    // Used for the donut chart + total count — includes completed projects,
    // since this widget represents everything the student has worked on.
    const allProjects = rawProjects;

    // Used for the 2 preview cards below the chart — only active (not yet
    // completed) projects make sense to show here, since each card has a
    // progress bar and a "Go to Project" action.
    const activeProjects = rawProjects.filter(
        (p) => p.progress_status !== "3"
    );

    const cards = activeProjects.slice(0, 2).map(mapProjectToCard);

    // Build donut chart data from ALL projects, not just active ones.
    const chartData = [
        { name: "Academic", value: 0 },
        { name: "Research", value: 0 },
        { name: "Personal", value: 0 },
        { name: "Other", value: 0 },
    ];

    allProjects.forEach((project) => {
        switch (project.type) {
            case "1":
                chartData[0].value++;
                break;
            case "2":
                chartData[1].value++;
                break;
            case "3":
                chartData[2].value++;
                break;
            case "4":
                chartData[3].value++;
                break;
            default:
                break;
        }
    });

    return (
        <DashboardCard
            sx={{
                p: 2,
                borderRadius: "13.38px",
                minHeight: 245,
            }}
            header={
                <SectionHeader
                    title="Your Projects"
                    actionText="View all"
                    onAction={onViewAll}
                />
            }
        >
            <Box
                sx={{
                    display: "flex",
                    gap: 2,
                    mt: 2,
                }}
            >
                <Box
                    sx={{
                        flex: "0 0 30%",
                        maxWidth: "30%",
                        pr: 2,
                        borderRight: "1px solid #E8EDF5",
                        overflow: "hidden",
                    }}
                >
                    <ProjectSummary
                        total={allProjects.length}
                        data={chartData}
                    />
                </Box>

                <Box
                    sx={{
                        flex: 1,
                        minWidth: 0,
                    }}
                >
                    <ProjectList
                        projects={cards}
                        onOpenProject={onOpenProject}
                    />
                </Box>
            </Box>
        </DashboardCard>
    );
}